import React from "react";
import "./Modal.css";
import { useSelector } from "react-redux";
import { selectHeading } from "../../store/globalSlice";

const CustomModal = ({ children, onClose, contact }) => {
  const noHeading = useSelector(selectHeading);
  return (
    <div className="modal-container">
      <div className={noHeading ? "contact-content" : "modal-content"}>
        {noHeading && (
          <div className="close-contact">
            <span onClick={onClose}>&#10799;</span>
          </div>
        )}
        {children}
        {!noHeading && !contact && <button onClick={onClose}>Close</button>}
      </div>
    </div>
  );
};

export default CustomModal;
